module.exports = __webpack_public_path__ + "img/ic_notebook_active.671bfe79.svg";